import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";

export default function AccidentTypesGrid({ items = [] }) {
  if (!items?.length) return null;
  return (
    <section className="section bg-bone-alt" data-testid="accident-types-section">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mb-12 md:mb-16">
          <div className="overline mb-3">Accident Types We Handle</div>
          <h2 className="text-3xl md:text-5xl font-display font-bold text-forest tracking-tight mb-4 text-balance">
            Every accident is different. Every claim deserves attention.
          </h2>
          <p className="text-base md:text-lg text-charcoal-soft leading-relaxed">
            From a fender-bender on the Schuylkill Expressway to a catastrophic truck crash on the
            Pennsylvania Turnpike, we connect Pennsylvania victims with attorneys who specialize in
            their specific situation.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {items.map((it, idx) => {
            const IconComp = Icons[it.icon] || Icons.AlertTriangle;
            const span = idx === 0 ? "lg:col-span-2 lg:row-span-2" : "";
            const featured = idx === 0;
            return (
              <Link
                key={it.id}
                to={`/accident-types/${it.slug}`}
                className={`group bg-white border border-black/5 rounded-2xl p-6 md:p-7 hover:border-forest/30 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col ${span}`}
                data-testid={`accident-card-${it.slug}`}
              >
                <div className={`w-12 h-12 rounded-xl ${featured ? "bg-terracotta text-white" : "bg-forest/5 text-forest"} grid place-items-center mb-5 group-hover:scale-110 transition-transform`}>
                  <IconComp className="w-6 h-6" />
                </div>
                <h3 className={`font-display font-bold ${featured ? "text-2xl md:text-3xl" : "text-lg md:text-xl"} text-forest mb-2 leading-tight`}>
                  {it.name}
                </h3>
                <p className={`text-charcoal-soft ${featured ? "text-base md:text-lg" : "text-sm"} leading-relaxed flex-1 mb-4`}>
                  {it.short_description}
                </p>
                <div className="flex items-center gap-2 text-terracotta font-bold text-sm group-hover:gap-3 transition-all">
                  Learn more <ArrowRight className="w-4 h-4" />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
